<template>
	<div class="codeha25d-scratch-container" id="scratchContainer">
		<div style="width: 100%;" class="codeha25d-scratch-wrapper">
			<div @click="onClickRun" id="runBtn" class="run-btn" :style="{right: `10px`,top: '10px'}" v-show="runBtnVisible">
				<div class="svg-area">
					<svg-icon icon-class="green-flag" />
				</div>
				<div class="run-text">运行</div>
			</div>
			<div class="codeha25d-scratch">
				<div style="flex: 1;position: relative" ref="codeahaWrapper" id="codeahaWrapper">
					<img class="codeha25d-editor__tip" @click="toggleCodeahaTipModal"
						:src="$g.img('edu_codeaha_tip/tip-btn.png')" />
					<div id="codeha25d-editor__modal" class="codeha25d-editor__modal" v-if="codeahaTipModalShow">
						<div class="codeha25d-editor__modal__container">
							<div id="level-tip-container" v-html="tips" @click="imageEnlargement"></div>
						</div>
						<div class="codeha25d-editor__modal__close" @click="toggleCodeahaTipModal"></div>
					</div>
          <div v-if="codeahaTipImgModalShow" class="codeha25d-editor-img__modal" @click="closeCodeha25dEditorImg">
            <div class="codeha25d-editor-img__modal__container">
              <img :src="codeahaTipImgSrc" style="width: 40rem" alt="">
            </div>
          </div>
					<codeaha25d-scratch-container
              v-if="codeahaReadToLoad"
              :workspace="workspace"
              :aha_lv_id="codeaha25d.aha_lv_id"
              :aha_game_width="codeaha25d.aha_game_width"
              :aha_speed="ahaSpeed"
              aha_code_lang="python"
						  @CodeahaManagerInitFinished="codeahaManagerInitFinished"
              @changeSpeed="changeSpeed"
          />
				</div>
				<!--<div class="editor-container">-->
				<div style="position: relative; float:left;" :style="{width: `calc(100% - ${width || canvasWidth}px)`}">
					<div style="width: 100%;">
						<div id="blocklyDiv" style="width: 100%;" :style="{height: `${scratchHeight || canvasHeight}px`}"></div>
					</div>
				</div>
				<inject-codeaha-scratch-js @injectCodeahaJSFinish="injectCodeahaJSFinish" />
				<!--</div>-->
			</div>
		</div>
	</div>
</template>

<script>
	import {
		interval,
		Scheduler
	} from 'rxjs'
	import {
		map,
		tap,
		take,
		takeUntil,
		filter
	} from 'rxjs/operators'
	import get from 'lodash/get'
	import jQuery from 'jquery'

	import InjectCodeahaScratchJS from './InjectCodeahaScratchJS'
	import Codeaha25dScratchContainer from './codeaha25d/Codeaha25dScratchContainer'
	const gameWidth = 800
	// 创建 BroadcastChannel 对象
	const eventBus = new BroadcastChannel('eventBus')
	export default {
		name: 'v3-code-block-codeaha-render',
		props: ['lang', 'code', 'uuid', 'type', 'width', 'scratchWidth', 'scratchHeight', 'practice', 'userHomeworkResult', 'gameSpeed'],
		components: {
			'inject-codeaha-scratch-js': InjectCodeahaScratchJS,
			'codeaha25d-scratch-container': Codeaha25dScratchContainer
		},
		data: function() {
			return {
				elementId: 'codeBlockCodeaha-' + this.uuid,
				editor: null,
				output: '',
				practiceId: null,
				injectJSLoadIntervalId: null,
				isInjectJSLoadClearInterval: false,
				injectCodeahaJSLoadFinish: false,
				btnStatus: 0,
				btnStatusIntervalId: null,
				codeahaReadToLoad: false,
				codeaha25d: null,
				codeahaButtons: [],
				workspace: null,
				btnDisabled: true,
				runBtnVisible: false,
				scratchBlocksMap: {
					move: 'aha_move',
					left: 'aha_turn_left',
					right: 'aha_turn_right',
					for: 'control_repeat',
					toggle: 'aha_toggle',
					push: 'aha_push',
					pickUp: 'aha_pick_up',
					build: 'aha_build',
					isBroken: 'aha_is_broken',
					get: 'aha_get',
					say: 'aha_say',
					if: 'control_if',
					isLightOn: 'aha_is_light_on',
					fire: 'aha_fire',
					hit: 'aha_hit',
					hasBlocked: 'aha_has_blocked',
					operator_lt: 'operator_lt',
					ifElse: 'control_if_else',
					ifElseIfElse: 'control_if_elif_else'
				},
				buttons: null,
				codeahaTipModalShow: false,
				tips: '',
				canvasWidth: gameWidth,
				canvasHeight: gameWidth * 450 / 540,
        ahaSpeed: this.gameSpeed || 1,
        codeahaTipImgModalShow: false,
        codeahaTipImgSrc: ''
			}
		},
		watch: {
			// 监听ID发生变化，重新加载游戏
			practice() {
				delete window['vueServices'].renderEditorComponentService
				delete window['vueServices'].setCodeaha25d
				if (!this.isInjectJSLoadClearInterval) clearInterval(this.injectJSLoadIntervalId)
				if (this.btnStatusIntervalId !== null) clearInterval(this.btnStatusIntervalId)

				this.injectJSLoadIntervalId = setInterval(() => {
					if (this.injectCodeahaJSLoadFinish) {
						this.init()
						clearInterval(this.injectJSLoadIntervalId)
						this.isInjectJSLoadClearInterval = true
					}
				}, 100)
				window['vueServices'].setCodeaha25d = this.setCodeaha25d
			},
			userHomeworkResult(nVal){ // 答案
			  if(this.runBtnVisible) {
          this.initWorkSpace()
        }
				console.log("scratch答案：", JSON.parse(JSON.stringify(nVal)));
			}
		},
		computed: {},
		created() {
			this.classroomId = this.$route.query.classroomId
			this.practiceId = this.$route.query.practiceId
			// this.lang = this.practice.lang
		},
		beforeDestroy: function() {
			this.handlerDestroyAnimationFrame()
			delete window['vueServices'].renderEditorComponentService
			delete window['vueServices'].setCodeaha25d
			if (!this.isInjectJSLoadClearInterval) clearInterval(this.injectJSLoadIntervalId)
			if (this.btnStatusIntervalId !== null) clearInterval(this.btnStatusIntervalId)
		},
		mounted: function() {
			this.initStreams()
			this.injectJSLoadIntervalId = setInterval(() => {
				if (this.injectCodeahaJSLoadFinish && window['Blockly']) {
					this.init()
					clearInterval(this.injectJSLoadIntervalId)
					this.isInjectJSLoadClearInterval = true
				}
			}, 100)
			window['vueServices'].setCodeaha25d = this.setCodeaha25d
			console.log("关卡信息ScratchRender：", JSON.parse(JSON.stringify(this.practice)));
			this.$nextTick(() => {
				let divElement = document.getElementById("scratchContainer");
				let height = divElement.clientHeight;
				let width = divElement.clientWidth;
				let canvasWidth = height * 540 / 450;
				if(width - canvasWidth < 500){ // 积木代码块最小宽度500
					canvasWidth = width - 500;
					height = canvasWidth*450/540;
				}
				this.canvasHeight = height;
				this.canvasWidth = canvasWidth;
			})
		},
		methods: {
			changeRunBtnClassDisabled() { // 加载场景时按钮状态
				const el = document.getElementById('runBtn')
				if (el === null) return false
				this.btnDisabled = true
				el.classList.add('run-btn--disabled')
				el.classList.remove('run-btn--common', 'run-btn--running')
			},
			changeRunBtnClassCommon() { // 可运行时按钮状态
				const el = document.getElementById('runBtn')
				if (el === null) return false
				this.btnDisabled = false
				el.classList.add('run-btn--common')
				el.classList.remove('run-btn--disabled', 'run-btn--running')
			},
			changeRunBtnClassRunning() { // 运行时按钮状态
				const el = document.getElementById('runBtn')
				if (el === null) return false
				this.btnDisabled = true
				el.classList.add('run-btn--running')
				el.classList.remove('run-btn--common', 'run-btn--disabled')
			},
			initStreams() {
				console.log("**************场景加载中*************");
				const handlerDestroyAnimationFrame$ = this.$createObservableMethod('handlerDestroyAnimationFrame').pipe(take(1))
				const animationFrame$ = interval(0, Scheduler.animationFrame)
				const statusActionMap = [
					this.changeRunBtnClassDisabled,
					this.changeRunBtnClassCommon,
					this.changeRunBtnClassRunning
				]

				const changeBtnClass$ = animationFrame$.pipe(
					takeUntil(handlerDestroyAnimationFrame$),
					map(_ => {
						const getRunBtnStatus = get(window, 'CodeahaManager.getRunBtnStatus', null)
						if (getRunBtnStatus === null) return null
						const status = getRunBtnStatus()
						return status
					}),
					filter(val => val !== null),
					tap(val => {
						statusActionMap[val]()
					})
				)

				changeBtnClass$.subscribe(
					() => {},
					error => {
						console.error('Error happened: ' + error)
					},
					() => {
						console.log('[streams: changeBtnClass$] the subscription is completed')
					}
				)
			},
			injectCodeahaJSFinish: function(val) {
				this.injectCodeahaJSLoadFinish = val
			},
			init: function() {
				this.btnStatusIntervalId = setInterval(() => {
					if (window['CodeahaManager'].getRunBtnStatus() === 1) {
						setTimeout(() => {
							this.btnStatus = 1
						}, 600)
					} else {
						this.btnStatus = window['CodeahaManager'].getRunBtnStatus()
					}
				}, 100)
				// try {
				this.initScratch()
				// } catch (e) {
				//   console.log(e)
				// }
			},
			codeahaManagerInitFinished() {
				this.runBtnVisible = true
				/* if(this.userHomeworkResult){
					console.log("----------答案信息：", JSON.parse(JSON.stringify(this.userHomeworkResult)))
					const decodeCode = this.$g.escape2Html(this.userHomeworkResult.result.code)
					console.log(decodeCode)
					if (decodeCode) {
						this.$nextTick(() => {
							window['Blockly'].Storage.loadWorkspaceByText(decodeCode)
						})
					}
				} */
				console.log("**************场景加载完成*************");
			},
			initScratch() {
				this.initWorkSpace()
				if (window.hasOwnProperty('vueServices') && window['vueServices'].hasOwnProperty('setCodeaha25d')) {
					window['vueServices'].setCodeaha25d({})
				}
			},
			initWorkSpace() {
				// var toolbox = document.getElementById('toolbox-categories')
				const toolbox = this.buildToolboxXml()
				window['Blockly'].ScratchMsgs.setLocale('zh-cn')
				// Create main workspace.
				this.workspace = window['Blockly'].inject('blocklyDiv', {
					comments: true,
					disable: false,
					collapse: false,
					media: '/static/codeaha25d/publish/html5/public/views/default/js/scratch-blocks/media/',
					readOnly: false,
					rtl: false,
					scrollbars: true,
					toolbox: toolbox,
					toolboxPosition: 'start',
					horizontalLayout: false,
					sounds: false,
					zoom: {
						controls: true,
						wheel: true,
						startScale: 0.75,
						maxScale: 4,
						minScale: 0.25,
						scaleSpeed: 1.1
					},
					colours: {
						fieldShadow: 'rgba(255, 255, 255, 0.3)',
						dragShadowOpacity: 0.6
					}
				})
				this.gameInitCode()
			},
      gameInitCode() {
        let startXml = this.getStartXml();
        if(this.userHomeworkResult && this.userHomeworkResult.result.code){
          startXml = this.userHomeworkResult.result.code;
        }
        console.log(startXml)
        window.Blockly.Xml.domToWorkspace(window.Blockly.Xml.textToDom(startXml), this.workspace)
      },
			getStartXml() {
				return `
          <xml xmlns="https://developers.google.com/blockly/xml" id="startBlocks" style="display: none">
            <block type="event_when_click_run_btn" id="event_when_click_run_btn" x="50" y="50"></block>
          </xml>
        `
			},
			setCodeaha25d: function(codeaha25d) {
				this.codeaha25d = codeaha25d
				this.loadCodeaha()
			},
			loadCodeaha: function() {
				const width = this.width || this.canvasWidth
				this.$set(this.codeaha25d, 'aha_game_width', width)
				this.codeaha25d.aha_game_width = width
				this.codeaha25d.aha_lv_id = parseInt(this.practice.id)
				this.codeahaReadToLoad = true
				this.tipTimer = setInterval(() => {
					if (window['CodeahaManager'] && window['CodeahaManager'].getTipsHtml) {
						this.tips = window['CodeahaManager'].getTipsHtml()
						clearInterval(this.tipTimer)
					}
				}, 500)
			},
			buildToolboxXml: function() {
				// eslint-disable-next-line camelcase
				const aha_lv_id = 'lab_depot_' + this.$g.aha_padding(this.practice.id, 3)
				this.buttons = window.CodeahaManager.getOperationButtons(aha_lv_id)
				console.log("关卡操作模块", JSON.parse(JSON.stringify(this.buttons)));
				this.buttons.findIndex(item => item === undefined) !== -1 && this.buttons.splice(this.buttons.findIndex(item =>
					item === undefined), 1)

				const blockIdArray = ['event_when_click_run_btn']
				for (let i = 0; i < this.buttons.length; i++) {
					blockIdArray.push(this.scratchBlocksMap[this.buttons[i].name])
				}
				const xml = this.getXML()
				const xmlDoc = jQuery.parseXML(xml)
				const xmlEl = jQuery(xmlDoc)
				xmlEl.find('#toolbox-categories').children().each((index, child) => {
					jQuery(child).children().each((index2, child2) => {
						const blockId = jQuery(child2).attr('id')
						if (blockIdArray.indexOf(blockId) === -1 && jQuery(child).attr('id') !== 'operators') {
							// 删除节点
							jQuery(child2).remove()
						}
					})
					if (jQuery(child).attr('id') !== 'operators' && jQuery(child).attr('id') !== 'data') {
						if (!jQuery(child).children().length) {
							jQuery(child).remove()
						}
					}
				})
				const oSerializer = new XMLSerializer()
				return oSerializer.serializeToString(xmlEl[0])
				// this.toolboxXml = this.getXML()
			},
			getXML() {
				const xml = '<xml id="toolbox-categories" style="display: none">\n' +
					'          <category name="开始" id="aha_events" colour="#FFD500" secondaryColour="#CC9900">\n' +
					'            <block type="event_when_click_run_btn" id="event_when_click_run_btn"></block>\n' +
					'          </category>\n' +
					'          <category name="人物移动" id="aha_move" colour="#4C97FF" secondaryColour="#3373CC">\n' +
					'            <block type="aha_move" id="aha_move">\n' +
					'              <value name="STEPS">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM">1</field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="aha_turn_left" id="aha_turn_left"></block>\n' +
					'            <block type="aha_turn_right" id="aha_turn_right"></block>\n' +
					'          </category>\n' +
					'          <category name="行为动作" id="aha_action" colour="#9966FF" secondaryColour="#774DCB">\n' +
					'            <block type="aha_toggle" id="aha_toggle"></block>\n' +
					'            <block type="aha_push" id="aha_push"></block>\n' +
					'            <block type="aha_pick_up" id="aha_pick_up"></block>\n' +
					'            <block type="aha_build" id="aha_build"></block>\n' +
					'            <block type="aha_fire" id="aha_fire"></block>\n' +
					'            <block type="aha_hit" id="aha_hit"></block>\n' +
					'          </category>\n' +
					'          <category name="输入输出" id="aha_io" colour="#D65CD6" secondaryColour="#BD42BD">\n' +
					'            <block type="aha_get" id="aha_get"></block>\n' +
					'            <block type="aha_say" id="aha_say">\n' +
					'              <value name="SAY">\n' +
					'                <shadow type="text">\n' +
					'                  <field name="TEXT"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'          </category>\n' +
					'          <category name="条件" id="aha_condition" colour="#4CBFE6" secondaryColour="#2E8EB8">\n' +
					'            <block type="aha_is_light_on" id="aha_is_light_on"></block>\n' +
					'            <block type="aha_is_broken" id="aha_is_broken"></block>\n' +
					'            <block type="aha_has_blocked" id="aha_has_blocked"></block>\n' +
					'          </category>\n' +
					'          <category name="控制" id="control" colour="#FFAB19" secondaryColour="#CF8B17">\n' +
					'            <block type="control_repeat" id="control_repeat">\n' +
					'              <value name="TIMES">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM">10</field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="control_if" id="control_if"></block>\n' +
					'            <block type="control_if_else" id="control_if_else"></block>\n' +
					'            <block type="control_if_elif_else" id="control_if_elif_else"></block>\n' +
					'          </category>\n' +
					'          <category name="变量" id="data" colour="#FF8C1A" secondaryColour="#DB6E00" custom="VARIABLE">\n' +
					'          </category>\n' +
					'          <category name="运算" id="operators" colour="#40BF4A" secondaryColour="#389438">\n' +
					'            <block type="operator_add" id="operator_add">\n' +
					'              <value name="NUM1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="NUM2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_subtract" id="operator_subtract">\n' +
					'              <value name="NUM1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="NUM2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_multiply" id="operator_multiply">\n' +
					'              <value name="NUM1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="NUM2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_divide" id="operator_divide">\n' +
					'              <value name="NUM1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="NUM2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_lt" id="operator_lt">\n' +
					'              <value name="OPERAND1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="OPERAND2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_lte" id="operator_lte">\n' +
					'              <value name="OPERAND1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="OPERAND2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_equals" id="operator_equals">\n' +
					'              <value name="OPERAND1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="OPERAND2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_equals_type_text" id="operator_equals_type_text">\n' +
					'              <value name="OPERAND1">\n' +
					'                <shadow type="text">\n' +
					'                  <field name="TEXT"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="OPERAND2">\n' +
					'                <shadow type="text">\n' +
					'                  <field name="TEXT"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_not_equals" id="operator_not_equals">\n' +
					'              <value name="OPERAND1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="OPERAND2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_gt" id="operator_gt">\n' +
					'              <value name="OPERAND1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="OPERAND2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_gte" id="operator_gte">\n' +
					'              <value name="OPERAND1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="OPERAND2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'            <block type="operator_and" id="operator_and"></block>\n' +
					'            <block type="operator_or" id="operator_or"></block>\n' +
					'            <block type="operator_not" id="operator_not"></block>\n' +
					'            <block type="operator_mod" id="operator_mod">\n' +
					'              <value name="NUM1">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'              <value name="NUM2">\n' +
					'                <shadow type="math_number">\n' +
					'                  <field name="NUM"></field>\n' +
					'                </shadow>\n' +
					'              </value>\n' +
					'            </block>\n' +
					'          </category>\n' +
					'        </xml>'
				return xml
			},
			onClickRun(callback) {
				if (this.btnDisabled) return
				console.log("**************游戏开始运行*************");
				// 运行状态分为3中 0：未运行 1：运行中 2：运行结束
				eventBus.postMessage({
					event: 'runningGame',
					data: 1
				})
				window['CodeahaManager'].run(this.postCode)
			},
			postCode(resultData) {
				console.log("**************游戏运行完成*************\n", resultData);
				eventBus.postMessage({
					event: 'runningGame',
					data: 2
				})
				if (this.practice.readOnly === 0 && resultData) {
					let code = window.Blockly.Python.workspaceToCode(this.workspace)
					let xmlCode = window.Blockly.Storage.getWorkspaceText()
					console.log("**************获取代码*************\n", xmlCode);
					// this.$parent.changeStatus(this.practice.index, data.result + 1, code, 0)
					// if (this.practice.item_id && this.practiceId) {

						// result，0运行失败 1普通通关 2完美通关
						const data = {
							codeContent: xmlCode,
							language: 1,
							result: parseInt(resultData.result) + 1
						}
						console.log("提交参数", JSON.parse(JSON.stringify(data)))
						this.$emit('commitResult', data)


						/* APIPostStudentPracticeItemCode({
							item_id: this.practice.item_id,
							practice_id: this.practiceId,
							type: 1,
							code: this.practice.code,
							result: data.result
						}).then(res => {
							console.log("***********", JSON.parse(JSON.stringify(res)));
							this.$g.HandleResult(res, null, () => {

							}, null, null, true, true)
						}) */
					// }
				}
			},
			toggleCodeahaTipModal() {
				this.codeahaTipModalShow = !this.codeahaTipModalShow
				this.$nextTick(() => {
					const el = window['jQuery']('#codeha25d-editor__modal')
					el.height(el.width() * 153 / 200)
					clearInterval(this.heightTimer)
				})
			},
      changeSpeed(e) {
        console.log(e)
        this.ahaSpeed = parseInt(e);
        this.$emit("changeSpeed", e);
        // this.codeahaReadToLoad = false;
        // this.$nextTick(()=>{
        // 	this.codeahaReadToLoad = true;
        // })
      },
      imageEnlargement(e) {
        if (e.target.nodeName === 'IMG') { // 判断点击富文本内容为img图片
          this.codeahaTipImgSrc = e.target.currentSrc
          this.codeahaTipImgModalShow = true
          console.log(e.target.currentSrc)
        } else {
          console.log('点击内容不为img')
        }
      },
      closeCodeha25dEditorImg() {
        this.codeahaTipImgSrc = ''
        this.codeahaTipImgModalShow = false
      }
		}
	}
</script>

<style scoped lang="scss">
	.codeha25d-scratch-container {
		width: 100%;
		height: 100%;

		.codeha25d-editor__tip {
			position: absolute;
			left: 10px;
			top: 10px;
			z-index: 15;
			width: 30px;
			cursor: pointer;
		}

		.codeha25d-editor__modal {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			width: 60%;
			background-image: url('../../../../../public/static/image/edu_codeaha_tip/tip-bg.png');
			background-repeat: no-repeat;
			background-size: 100% auto;
			z-index: 16;
			display: flex;
			justify-content: center;
			align-items: center;

			&__container {
				width: 90%;
				height: 75%;
				overflow: auto;
				padding: 0 0 20px;
			}

			&__close {
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
				height: 12%;
				z-index: 17;
			}
		}

    .codeha25d-editor-img__modal{
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 17;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.8);
    }

		.codeha25d-scratch-wrapper {
			width: 100%;
			position: relative;

			.run-btn {
				width: 100px;
				height: 40px;
				margin-bottom: 1px;
				position: absolute;
				z-index: 1;
				bottom: -55px;
				border-radius: 20px;
				border: 3px solid #7998c1;
				font-weight: 500;

				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;

				.svg-area {
					font-size: 25px;
					position: absolute;
					top: 5px;
					left: 12px;
				}

				.run-text {
					margin-left: 22px;
					font-size: 16px;
				}
			}

			.codeha25d-scratch {
				display: flex;
				width: 100%;
			}
		}
	}
</style>

<style lang="scss">
	.blocklyToolboxDiv {
		background-color: #f9f9f9;

		.scratchCategoryMenu {
			background-color: #f9f9f9;
		}
	}

	.blocklySvg {
		background-color: #fff;
	}

	.blocklyMainWorkspaceScrollbar {
		display: none !important;
	}

	.codeha25d-scratch-wrapper {
		.run-btn--common {
			border-color: #5188e6 !important;
			background-color: #6098f5;
			color: white;
			cursor: pointer;
			transition: all .3s ease;
		}

		.run-btn--running {
			border-color: #33b8eb !important;
			background-color: #62cff6;
			color: white;
			cursor: not-allowed;
			transition: all .3s ease;
		}

		.run-btn--disabled {
			border-color: #7998c1 !important;
			background-color: #c9d6e6;
			color: #7998c1;
			cursor: not-allowed;
			transition: all .3s ease;
		}
	}
</style>

<style scoped lang="scss">
	.codeha25d-scratch {
		::v-deep {
			#level-tip-container {
				color: #fff;
				line-height: 32px;
				font-family: "黑体";
				width: 100%;
				font-size: 12px;
				position: relative;
				-ms-overflow-style: none;

				&::-webkit-scrollbar {
					width: 0 !important
				}

				img {
					height: 42px;
				}
			}

			.level-tip-content {
				height: 100%;
				overflow-y: auto;
				box-sizing: border-box;
				padding-right: 60px;
			}

			.level-tip-scroll-tip {
				font-size: 20px;
				width: 37px;
				line-height: 24px;
				position: absolute;
				bottom: 0px;
				right: 50px;
				/* color: rgba(37, 130, 214, 255); */
				display: none;
			}

			.bgcolor-light {
				background: rgba(0, 255, 255, 255)
			}

			.color-yellow {
				color: #ff0;
			}
		}
	}
</style>


<style>
	#blocklyDiv .blocklyToolboxDiv .scratchCategoryMenu .scratchCategoryMenuItemLabel{
		font-size: 12px;
	}
</style>
